// Routes started
export const LOGIN = "/";
export const FINANCE_DASHBOARD = "/dashboard";
export const DELAER_DASHBOARD_ROUTE = "/dealer_dashboard";
export const VALIDATION_ROUTE = "/validations";
export const PAYOUT_ARCHIVE_ROUTE = "/payoutsArchive";
export const PAYOUT_DEALER_SUMMARY_ROUTE = "/payoutsDealerSummary";

export const PAYOUT_ROUTE = "/payouts";
export const ON_HOLD_ROUTE = "/onhold";
export const CONTACT_ROUTE = "/contacts";
export const INVOICES_ROUTE = "/invoices";
export const FORMS_ROUTE = "/form";
export const EXCLUSION_ROUTE = "/exclusion";
export const PAYOUT_DATES_ROUTE = "/payoutDates";
export const WITHOLDING_TAX_ROUTE = "/withHoldingTax";
export const FREEZE_ACCOUNT_ROUTE = "/freezeAccount";
export const CREDIT_DEBIT_ROUTE = "/creditDebit";
export const REPORTS_ROUTE = "/reports";
export const REPORTS_FILTER_ROUTE = "/reportDetails";
export const PAYOUT_TRANSACTION_DETAILS = "/payoutsTransactionDetails";
export const PAYOUT_ALL_TRANSACTION_DETAILS = "/payoutsAllTransactionDetails";
export const PAYOUT_DEALER_BREAKDOWN = "/payoutsDealerBreakdown";
export const ON_HOLD_DETAILS_ROUTE = "/onHoldDetails";
export const ON_HOLD_DEALERS_ROUTE = "/onHoldDealers";
export const ON_HOLD_ALL_TRANSACTIONS_DETAILS = "/onHoldAllTransactions";
export const SUCCESS_ROUTE = "/success";
export const ADD_DEALER_ROUTE = "/addDealer";
export const UNFREEZE_FREEZE_DEALER_ROUTE = "/FreezeUnfreezeDealer";
export const ADD_ADJUSTMENTS_ROUTE = "/addAdjustments";
export const SEARCH_DEALER_CREDIT_DEBIT_ROUTE = "/searchDealerCreditDebit";
export const CANCEL_ADJUSTMENT_SUCCESS_ROUTE = "/CancelAdjustmentSuccess";
export const ON_HOLD_ACTION_ITEM_SUCCESS_ROUTE = "/OnHoldActionItemsSuccess";
export const ADJUSTMENT_SUCCESS_ROUTE = "/AdjustmentSuccess";
export const ADD_EXCLUSION_DEALER_ROUTE = "/AddExclusionDealer";
export const PAYOUTS_ACTION_ITEMS_SUCCESS_ROUTE = "/PayoutsActionItemsSuccess";

export const ADD_ADJUSTMENT_TO_EXCLUSION_ROUTE = "/AddAdjustmentToExclusion";
export const REMOVED_EXCLUSION_TRANSACTION_TYPE_ROUTE = "/RemovedExclusionTransactionTypeScreen";
export const REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE = "/RemovedExclusionTransacionDetails";
export const REMOVED_EXCLUSION_TRANSACTIONS_ROUTE = "/RemovedExclusionTrasactionData";
export const ON_HOLD_PAYOUT_CYCLE_ROUTE = "/onHoldPayoutCycle";


export const CASHOUT_LIMITS_ROUTE = "/cashOutLimits";
export const EXCLUSION_SUCCESS_ROUTE = "/SuccessPage";
export const CHANGE_PASSWORD_ROUTE = "/ChangePassword";
export const CHANGE_USERNAME_ROUTE = "/ChangeUsername";
export const FORGOT_PASSWORD_ROUTE = "/ForgotPassword";
export const FORGOT_USERNAME_ROUTE = "/ForgotUsername";

export const SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE = "/SearchAndSelectCompanyDetails";


export const CHANGE_PASSWORD = "/changePassword";
export const RESET_PASSWORD_ON_URL_LINK_CLICK = "/resetForgotPassword";




export const ADJUSTMENT_ROUTE = "/adjustment";
export const EARMARK_ROUTE = "/earmark";

export const HIERARCHY_ROUTE = "/hierarchy";
export const REQUEST_ROUTE = "/request";
export const MODULES_ROUTE = "/modules";
export const MODULES_UPDATE_SUCCESS_ROUTE = "/modulesUpdateSuccess";
export const ROLES_ROUTE = "/roles";
export const CREATE_ROLES_ROUTE = "/createRoles";
export const USERS_ROUTE = "/users";
export const LOG_ROUTE = "/log";
export const LOG_DETAILS_ROUTE = "/logDetails";
export const REQUEST_DETAILS_ROUTE = "/requestDetails";
export const CLUSTER_LISTING_ROUTE = "/clusters";
export const CLUSTER_DETAILS_ROUTE = "/clusterDetails";
export const CREATE_CLUSTER_ROUTE = "/createCluster";
export const EDIT_CLUSTER_ROUTE = "/editCluster";
export const ASSIGN_USERS_TO_CLUSTER_ROUTE = "/assignUsersToCluster";
export const ASSIGN_ROLES_TO_CLUSTER_ROUTE = "/assignRolesToCluster";

// Routes end

// Other Common String
export const OPEN_SLIDING_MENU = "openSlidingMenu";
export const COLLAPSE_MENU = "collapseMenu";
export const PROGRESS_STATUS = "progressStatus";
export const ERROR_TITLE = "errorTitle";
export const ERROR_CONTENT = "errorContent";

export const IS_AUTH_PAGE = "isAuthPage";
export const ERROR_IN_LOADING_REPORT_NAMES = "Error in loading Report Names, Please try again!"
export const GET_DIALOG_STATUS = "getDialogStatus";
export const GET_SUCCESS_DIALOG_STATUS = "getSuccessDialogStatus";


export const SELECTED_BATCH_NUMBER = "batchNumber";
export const INITIATE_FILE_DOWNLOAD = "initiateFileDownload";



export const GET_SESSION_ID_STATUS = "getSessionIdStatus";
export const GLOBAL_SEARCH = "global-search";
export const SELECTED_TAB = "selected-tab";

export const GET_DIALOG_DATA = "dialog-params";

export const NAVIGATION_DATA = "nav_data";
export const NAVIGATION_PAYOUT_ALL_TRANSACTION_DATA =
  "nav_payout_all_tranascation_data";

export const DARK_MODE = "darkMode";
export const AUTHORIZATION = "Authorization";
export const CONTENT_TYPE = "Content-Type";
export const APPLICATION_JSON = "application/json";
export const MULTIPART_DATA = "multipart/form-data";

// Arrays
export const ACTIVITY_PERIODS = Object.freeze({
  THREE_MONTHS: 'Past 3 Months',
  SIX_MONTHS: 'Past 6 Months',
  ONE_YEAR: 'Past 1 Year',
});

export const postingOptions = [
  { value: "scheduled", label: "Scheduled" },
  { value: "posted", label: "Immediate" },
  { value: "cancelled", label: "Cancelled" },
];

export const typeOptions = [
  { value: "", label: "Select a Report Type" },
  { value: "type1", label: "CREDIT" },
  { value: "type2", label: "DEBIT" },
];

export const reportFilterOptions = [
  { value: "", label: "Select a Filter Type" },
  { value: "TEXTBOX", label: "TEXTBOX" },
  { value: "CALENDAR", label: "CALENDAR" },
  { value: "DROPDOWN", label: "DROPDOWN" },
];

export const reportDateOptions = [
  { value: "", label: "Select a Date" },
  { value: "type1", label: "01/01/2024" },
  { value: "type2", label: "01/02/2024" },
  { value: "type3", label: "01/03/2024" },
];

export const descriptionOptions = [
  { value: "", label: "Select an option" },
  { value: "description1", label: "Rental" },
  { value: "description2", label: "Fraud Case" },
  { value: "description3", label: "Clawback incentive" },
  { value: "description4", label: "Clawback device" },
  { value: "description5", label: "Double Payment for Incentive" },
  { value: "description6", label: "Double Payment for device reimbursement" },
  { value: "description7", label: "Double Bill Payment/ Reload / Add On" },
  { value: "description8", label: "Electricity" },
  { value: "description9", label: "Others" }
];
